window.$ = window.jQuery

window.documentReady(() => {
	const classOpened = 'mobile-nav-opened'
	const classCFOpened = 'contact-form-opened'

	const closeNav = () => {
		window.removeClass(document.body, classOpened)
	}

	const closeContactForm = () => {
		window.removeClass(document.body, classCFOpened)
	}

	// Mobile navigation toggling
	const toggleNav = () => {
		const hasOpenedClass = window.hasClass(document.body, classOpened)

		if(hasOpenedClass) {
			window.removeClass(document.body, classOpened)
		} else {
			closeContactForm()
			window.addClass(document.body, classOpened)
		}
	}

	const mobileNavToggle = document.querySelectorAll('.toggle-mobile-nav')
	if(1 === mobileNavToggle.length){
		mobileNavToggle[0].addEventListener('click', (e) => {
			e.preventDefault()
			toggleNav()
		})
	}


	// Mobile navigation toggling
	const toggleContactForm = () => {
		const CFhasOpenedClass = window.hasClass(document.body, classCFOpened)

		if(CFhasOpenedClass) {
			window.removeClass(document.body, classCFOpened)
		} else {
			closeNav()
			window.addClass(document.body, classCFOpened)
		}
	}

	const contactFormToggle = document.querySelectorAll('.toggle-contact-form')
	if(contactFormToggle.length > 0){
		const contactFormListener = (e) => {
			e.preventDefault()

			toggleContactForm()
		}
		Array.prototype.forEach.call(contactFormToggle, (el) => {
			el.addEventListener('click', contactFormListener)
		})
	}


	// Scroll links - scroll to anchor
	document.querySelectorAll('a[data-toggle="scroll"]').forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault()
			const targetElement = document.getElementById(link.getAttribute('href').substr(1))
			window.scrollToElement(document.documentElement, targetElement.offsetTop)
		})
	})


	const initHpSlider = () => {
		const activeClass = 'slick-active'
		const ariaAttribute = 'aria-hidden'
		const $slider = $('#hp-slider')

		if (1 === $slider.length) {
			//var $carouselNav = $slider.next(".carousel-nav");
			const $carouselDots = $slider.parent().find('.carousel-dots')

			// On before slide change
			$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
				const $nextSlide = $(slick.$slides.get(nextSlide))



				$slider.parent()
					.removeClass('blue orange')

				if ($nextSlide.hasClass('blue')) {
					$slider.parent().addClass('blue')
				} else if ($nextSlide.hasClass('orange')) {
					$slider.parent().addClass('orange')
				}
				// On after slide change
			}).on( 'afterChange', (event, slick, currentSlide ) => {
				const $dots = $slider.parent().find('.carousel-dots-hover .slick-dots')
				$dots.find('li').removeClass(activeClass).attr(ariaAttribute, true).eq(currentSlide).addClass(activeClass).attr(ariaAttribute, false)

				const $currentSlide = $(slick.$slides.get(currentSlide))
				slick.$slides.find('.animate').removeClass('animated revert-animation')
				$currentSlide.find('.animate').addClass('animated')

				setTimeout(() => {
					slick.$slides.find('.animated').addClass('revert-animation')
				}, 4500)

			}).on('init', (event, slick) => {
				const firstSlide = $(slick.$slides.get(0))

				firstSlide.find('.animate').addClass('animated')

				setTimeout(() => {
					slick.$slides.find('.animated').addClass('revert-animation')
				}, 4500)

				$slider.parent()
					.removeClass('blue orange')

				if (firstSlide.hasClass('blue')) {
					$slider.parent().addClass('blue')
				} else if (firstSlide.hasClass('orange')) {
					$slider.parent().addClass('orange')
				}

				// create second dots nav
				$slider.parent().find('.carousel-dots ul.slick-dots').clone(true, true).appendTo($slider.parent().find('.carousel-dots-hover'))
				$slider.find('.carousel-dots-hover .slick-dots li:first-of-type' ).addClass(activeClass).attr( ariaAttribute, false)

				// append slick slides count to dots
				$slider.parent().find('.carousel-dots ul.slick-dots').append(`<li class="count">0${slick.$slides.length}</span></li>`)
			})

			$slider.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplaySpeed: 7000,
				pauseOnHover: false,
				pauseOnFocus: false,
				autoplay: true,
				arrows: false,
				fade: true,
				//appendArrows: $carouselNav,
				appendDots: $carouselDots,
				dots: true,
				//prevArrow: $carouselNav.find('.prev-slide'),
				//nextArrow: $carouselNav.find('.next-slide')
			})
		}
	}


	const initCoRobimeSlider = () => {
		const $slider = $('#co-robime-slider')
		if (1 === $slider.length) {
			//var $carouselNav = $slider.next(".carousel-nav");

			// On before slide change
			$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
				const $nextSlide = $(slick.$slides.get(nextSlide))

				$slider.parent()
					.removeClass('blue orange')

				if ($nextSlide.hasClass('blue')) {
					$slider.parent().addClass('blue')
				} else if ($nextSlide.hasClass('orange')) {
					$slider.parent().addClass('orange')
				}
			}).on('init', (event, slick) => {
				const firstSlide = $(slick.$slides.get(0))

				$slider.parent()
					.removeClass('blue orange')

				if (firstSlide.hasClass('blue')) {
					$slider.parent().addClass('blue')
				} else if (firstSlide.hasClass('orange')) {
					$slider.parent().addClass('orange')
				}

				// append slick slides count to dots
				$slider.parent().find('ul.slick-dots').append(`<li class="count">0${slick.$slides.length}</span></li>`)
			})

			$slider.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				waitForAnimate: false,
				arrows: false,
				cssEase: 'ease-out',
				fade: true,
				dots: false,
				//prevArrow: $carouselNav.find('.prev-slide'),
				//nextArrow: $carouselNav.find('.next-slide')
			})
		}

		const $services = $('ul.services')
		const $servicesLi = $services.find('li')


		$services.on('mouseenter', 'li', (e) => {
			const $this = $(e.currentTarget)

			if($this.hasClass('active')){
				e.preventDefault()
			}

			const index = $servicesLi.index($this)

			$servicesLi.removeClass('active')
			$this.addClass('active')
			$slider.slick('slickGoTo', index)

		})
	}


	const initClientsSlider = () => {
		const $slider = $('#clients-slider')
		if (1 === $slider.length) {
			$slider.slick({
				slidesToShow: 7,
				slidesToScroll: 1,
				arrows: false,
				autoplay: true,
				dots: false,
				responsive: [
					{
						breakpoint: 1024,
						settings: {slidesToShow: 5}
					},
					{
						breakpoint: 600,
						settings: {slidesToShow: 3}
					},
					{
						breakpoint: 480,
						settings: {slidesToShow: 2}
					}
				]
				//prevArrow: $carouselNav.find('.prev-slide'),
				//nextArrow: $carouselNav.find('.next-slide')
			})
		}
	}


	const initInstagramSlider = () => {
		const $slider = $('#instagram-slider')
		if (1 === $slider.length) {
			$slider.slick({
				slidesToShow: 5,
				slidesToScroll: 1,
				arrows: false,
				autoplay: true,
				dots: false,
				responsive: [
					{
						breakpoint: 1024,
						settings: {slidesToShow: 4}
					},
					{
						breakpoint: 600,
						settings: {slidesToShow: 3}
					},
					{
						breakpoint: 480,
						settings: {slidesToShow: 2}
					}
				]
				//prevArrow: $carouselNav.find('.prev-slide'),
				//nextArrow: $carouselNav.find('.next-slide')
			})
		}
	}


	// init sliders
	initHpSlider()
	initCoRobimeSlider()
	initClientsSlider()
	initInstagramSlider()

	$('.parallax').paroller()
	$(window).scroll()

	// eslint-disable-next-line no-use-before-define
	const initAOS = () => {
		AOS.init({
			duration: 1000,
			easing: 'ease-out-cubic',
			anchorPlacement: 'center-bottom',
			once: true
		})
	}

	const aosContent = $('.aos-content')
	if(aosContent.length > 0){
		aosContent.children().each((i,el) => {
			$(el)//.attr('data-aos-delay', i*100)
				.attr('data-aos', 'fade-up')
				.attr('data-aos-once', 'true')

			initAOS()
		})
	} else {
		initAOS()
	}

	$('select').each((i,el) => {
		// eslint-disable-next-line
		new SlimSelect({
			select: el,
			showSearch: false,
		})
	})


	/*
		AJAX loading (blog posts 'load more' button etc.)
	 */

	$('.ajax-load-more').click((e) => {
		e.preventDefault()

		const button = $(e.currentTarget),
			data = {
				'action': 'blog_loadmore',
				'query': blog_loadmore_params.posts, // that's how we get params from wp_localize_script() function
				'page' : blog_loadmore_params.current_page
			}



		$.ajax({ // you can also use $.post here
			url : blog_loadmore_params.ajaxurl, // AJAX handler
			data,
			type : 'POST',
			beforeSend : () => {
				button.html('<span>Načítavam...</span>') // change the button text, you can also add a preloader image
			},
			success : (response) => {
				if( response ) {
					button.html('<span>Ďalšie články</span>')
					$('.ajax-container').append(response) // insert new posts
					blog_loadmore_params.current_page++

					if (blog_loadmore_params.current_page == blog_loadmore_params.max_page)
					{button.remove()} // if last page, remove the button
				} else {
					button.remove() // if no data, remove the button as well
				}
			}
		})
	})


	if($('body').hasClass('page-nasa-praca')){
		window.canBeLoaded = showcase_loadmore_params.max_page > 1

		// Register scroll event
		$(window).scroll(function(){
			const	data = {
				'action': 'showcase_loadmore',
				'query': showcase_loadmore_params.posts, // that's how we get params from wp_localize_script() function
				'page' : showcase_loadmore_params.current_page
			}

			if( window.pageYOffset > ( $(window).height()/4 ) && window.canBeLoaded) {
				$.ajax({
					url: showcase_loadmore_params.ajaxurl, // AJAX handler
					data,
					beforeSend: () => {
						// the AJAX call is in process, we shouldn't run it again until complete
						window.canBeLoaded = false
					},
					type: 'POST',
					success: (response) => {
						if (data) {
							$('.ajax-container').append(response) // insert new posts
							showcase_loadmore_params.current_page++
							if (showcase_loadmore_params.current_page == showcase_loadmore_params.max_page){
								window.canBeLoaded = false
							} else {
								window.canBeLoaded = true // the ajax is completed, now we can run it again
							}
						}
					}
				})
			}
		})
	}
})
